export default __webpack_public_path__ + "static/media/icon-twitter.f1c720cd.svg";